/**
 * {@link http://stackoverflow.com/questions/12756159/regex-and-iso8601-formated-datetime}
 */
// Support full ISO8601 spec with RegEx, borrowed from
// https://github.com/moment/moment/blob/develop/src/lib/create/from-string.js
const ISO8601 = new RegExp(
    '^\\s*((?:[+-]\\d{6}|\\d{4})-(?:\\d\\d-\\d\\d|W\\d\\d-\\d|W\\d\\d|\\d\\d\\d' +
        '|\\d\\d))(?:(T| )(\\d\\d(?::\\d\\d(?::\\d\\d(?:[.,]\\d+)?)?)?)([\\+\\-]\\d\\d(?::?\\d\\d)?|\\s*Z)?)?$'
)

/**
 * @typedef {string} ISO8601
 *
 * {@link https://facebook.github.io/react/docs/typechecking-with-proptypes.html}
 */
function createIso8601PropType(isRequired) {
    // The factory returns a custom prop type
    return function (props, propName, componentName) {
        const prop = props[propName]

        if (prop === undefined) {
            // Prop is missing
            if (isRequired) {
                // Prop is required but wasn't specified. Throw an error.
                return new Error(`Property '${propName}' is marked as required at '${componentName}' but was omitted`)
            }
            // Prop is optional. Do nothing.
        }

        // See https://www.ian-thomas.net/custom-proptype-validation-with-react/
        // See https://github.com/facebook/react/blob/0.13-stable/src/classic/types/ReactPropTypes.js#L91
        if (prop && !ISO8601.test(prop)) {
            return new Error(`Invalid ISO8601 property '${propName}' supplied to '${componentName}': ${prop}`)
        }
    }
}

// Using the factory, create two different versions of your prop type
export const iso8601PropType = createIso8601PropType(false)
iso8601PropType.isRequired = createIso8601PropType(true)
